import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebase';

// Feature flag for premium player notifications (set to true when ready to launch)
const PREMIUM_NOTIFICATIONS_ENABLED = true;

// Feature flag to show/hide Connect to CueScore button
const SHOW_CONNECT_CUESCORE = false;

function HomePage() {
  const navigate = useNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  // Check if user is already logged in
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is logged in, redirect to dashboard
        navigate('/organiser-dashboard');
      } else {
        setCheckingAuth(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleManualSetup = () => {
    navigate('/manual-setup');
  };

  const buttonStyle = {
    width: '100%',
    padding: '32px',
    borderRadius: '12px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '24px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    transition: 'all 0.3s ease'
  };

  const activeButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#2563eb',
    color: 'white'
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#374151',
    color: '#6b7280',
    cursor: 'not-allowed'
  };

  // Show loading while checking authentication
  if (checkingAuth) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#111827', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontSize: '18px', color: '#9ca3af' }}>Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#111827', color: 'white', padding: '48px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <h1 style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '16px' }}>
            🎱 Cue Clock Pro
          </h1>
          <p style={{ fontSize: '18px', color: '#9ca3af' }}>
            Select an option to get started
          </p>
        </div>

        {/* Buttons - New Order: Manual, Organiser, Notifications, Tablet */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          
          {/* 1. Manual Match Setup - Active */}
          <button
            onClick={handleManualSetup}
            style={{
              ...activeButtonStyle,
              boxShadow: '0 4px 20px rgba(37, 99, 235, 0.4)'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
          >
            <span style={{ fontSize: '32px' }}>✏️</span>
            <div style={{ textAlign: 'left' }}>
              <div>Manual Match Setup</div>
              <div style={{ fontSize: '16px', fontWeight: 'normal', marginTop: '4px' }}>
                Quick Start - Create Independent Match
              </div>
            </div>
          </button>

          {/* 2. Organiser Login - Active */}
          <button
            onClick={() => navigate('/organiser-login')}
            style={activeButtonStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
          >
            <span style={{ fontSize: '32px' }}>🎯</span>
            <div style={{ textAlign: 'left' }}>
              <div>Organiser Login</div>
              <div style={{ fontSize: '16px', fontWeight: 'normal', marginTop: '4px' }}>
                Tournament Management
              </div>
            </div>
          </button>

          {/* 3. Get CueScore Match Notifications - Active (green) */}
          {PREMIUM_NOTIFICATIONS_ENABLED && (
            <button
              onClick={() => navigate('/player-registration')}
              style={{
                ...activeButtonStyle,
                backgroundColor: '#10b981',
                boxShadow: '0 4px 20px rgba(16, 185, 129, 0.4)'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#059669'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#10b981'}
            >
              <span style={{ fontSize: '32px' }}>🔔</span>
              <div style={{ textAlign: 'left' }}>
                <div>Get CueScore Match Notifications</div>
                <div style={{ fontSize: '16px', fontWeight: 'normal', marginTop: '4px' }}>
                  Never miss a match - FREE!
                </div>
              </div>
            </button>
          )}

          {/* 4. Tablet Login - Active */}
          <button
            onClick={() => navigate('/tablet-login')}
            style={activeButtonStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}
          >
            <span style={{ fontSize: '32px' }}>📺</span>
            <div style={{ textAlign: 'left' }}>
              <div>Tablet Login</div>
              <div style={{ fontSize: '16px', fontWeight: 'normal', marginTop: '4px' }}>
                Link to Match Display
              </div>
            </div>
          </button>

          {/* Connect to CueScore - Hidden by default (SHOW_CONNECT_CUESCORE = false) */}
          {SHOW_CONNECT_CUESCORE && (
            <button
              disabled
              style={disabledButtonStyle}
              title="Coming soon - Import match data from CueScore"
            >
              <span style={{ fontSize: '32px' }}>🔗</span>
              <div style={{ textAlign: 'left' }}>
                <div>Connect to CueScore</div>
                <div style={{ fontSize: '16px', fontWeight: 'normal', marginTop: '4px' }}>
                  Import Match Data (Coming Soon)
                </div>
              </div>
            </button>
          )}

        </div>

      </div>
    </div>
  );
}

export default HomePage;